import { render, staticRenderFns } from "./NoSensorsMessage.vue?vue&type=template&id=43d6e684&"
import script from "./NoSensorsMessage.vue?vue&type=script&lang=js&"
export * from "./NoSensorsMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./NoSensorsMessage.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43d6e684')) {
      api.createRecord('43d6e684', component.options)
    } else {
      api.reload('43d6e684', component.options)
    }
    module.hot.accept("./NoSensorsMessage.vue?vue&type=template&id=43d6e684&", function () {
      api.rerender('43d6e684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Activity/NoSensorsMessage.vue"
export default component.exports